import type { PillTone } from '../components/PillGroup.js';

// Claves neutras (REGLA #6) + las 3 legacy en español que puedan quedar sin
// migrar en algún ambiente todavía — antes este mapeo vivía copiado en
// ContactsPage.tsx y ContactDetail.tsx, y solo uno de los dos manejaba el
// vocabulario legacy: el mismo contacto se veía con tono distinto según qué
// pantalla lo mostrara.
export function getContactCategoryTone(category: string): PillTone {
  switch (category) {
    case 'client':
    case 'Clientes': return 'cyan';
    case 'personal':
    case 'Personales': return 'warn';
    case 'prospect':
    case 'Prospectos': return 'blue';
    default: return 'muted';
  }
}
